module.exports = __webpack_public_path__ + "img/cancel.e7980a9c.svg";